import { createUseStyles } from 'react-jss'
import clsx from 'clsx'
import BannerImageVideo from '@/components/BannerImageVideo'
import style from './style'

const useStyles = createUseStyles(style)

function ImageText({ title, paragraph, link, image, alignment, paragraph_bgcolor, theme }) {
  const classes = useStyles()

  return (
    <div className={clsx({
      [classes.root]: true,
      [classes.rootDark]: theme === 'dark',
    })}
    >
      <BannerImageVideo
        data={{
          video: undefined,
          title,
          text: paragraph,
          link: link.url,
          label: link.title,
          image: image?.sizes?.large?.url || image?.url,
          imageAlt: image?.alt,
          imageTitle: image?.title,
          icon: undefined,
        }}
        bgcolor={paragraph_bgcolor}
        className={`layout_${alignment === 'right' ? 1 : 0}`}
      />
    </div>
  )
}

export default ImageText
